<template>
  <section id="page-car">
    <div class="container">
      <div class="row">

        <clearfix :biggest="true" :bootstrap="true"></clearfix>

        <div class="col-sm-12 content og-bg-dark">
          <div class="car-price">
            <div :class="editableClasses" v-show="!editPrice" @click="startPriceEdit" class="data">{{ car.price }}</div>
            <div v-show="editPrice">
              <input type="text" v-model="car.price">
              <b-button :size="'large'" :variant="'secondary'" @click="updatePrice">
                <icon name="plus-square"></icon>&nbsp;
                {{ $t('message.button.save') }}
              </b-button>
            </div>
          </div>
          <div>
            <h4 class="car-name data" :class="editableClasses" v-show="!editBrand" @click="startBrandEdit">{{ car.brand
              }}</h4>
            <div v-show="editBrand" class="inline-control">
              <input type="text" v-model="car.brand">
              <b-button class="inline-control" :size="'large'" :variant="'secondary'" @click="updateBrand">
                <icon name="plus-square"></icon>&nbsp;
                {{ $t('message.button.save') }}
              </b-button>
            </div>

            <div class="inline-control data" :class="editableClasses" v-show="!editModel" @click="startModelEdit">
              {{car.model}}
            </div>
            <div class="inline-control" v-show="editModel">
              <input type="text" v-model="car.model">
              <b-button class="inline-control" :size="'large'" :variant="'secondary'" @click="updateModel">
                <icon name="plus-square"></icon>&nbsp;
                {{ $t('message.button.save') }}
              </b-button>
            </div>

            <div class="inline-control data" :class="editableClasses" v-show="!editYear" @click="startYearEdit">({{
              car.year }})
            </div>
            <div class="inline-control" v-show="editYear">
              <input type="text" v-model="car.year">
              <b-button class="inline-control" :size="'large'" :variant="'secondary'" @click="updateYear">
                <icon name="plus-square"></icon>&nbsp;
                {{ $t('message.button.save') }}
              </b-button>
            </div>
          </div>
        </div>

        <clearfix :bootstrap="true"></clearfix>

        <div class="col-sm-12 content og-bg-light">
          <div class="data" :class="editableClasses" v-show="!editDescription" @click="startDescriptionEdit" v-html="car.description"></div>
          <div v-show="editDescription">
            <label for="car-description">{{ $t('message.form.description') }}</label><br>
            <quill-editor id="car-description"
                          v-model="car.description"
                          @change="changeDescription"
                          :options="quillOptionsDescription"></quill-editor>
            <br>
            <b-button :size="'large'" :variant="'secondary'" @click="updateDescription">
              <icon name="plus-square"></icon>&nbsp;
              {{ $t('message.button.save') }}
            </b-button>
          </div>
        </div>

        <clearfix :bootstrap="true"></clearfix>

        <clearfix :wide="true" :bootstrap="true"></clearfix>

        <div class="col-sm-12 content og-bg-light" v-show="car.photos.length > 0">
          <gallery :images="preparePhotos(true)" :index="index" @close="index = null"></gallery>
          <div class="gallery-photo" v-for="(photo, photoIndex) in preparePhotos()" :key="photoIndex"
               @click="index = photoIndex"
               :style="{ backgroundImage: 'url(\'' + $t(imageBase, {car_id: car.id, file_name: photo}) + '\')', width: '300px', height: '200px' }">
          </div>
        </div>

        <clearfix :biggest="true" :bootstrap="true"></clearfix>
      </div>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import _ from 'underscore'
  import {quillEditor} from 'vue-quill-editor'
  import miniToastr from 'mini-toastr'
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'
  import VueGallery from 'vue-gallery'
  import Clearfix from '../utils/Clearfix'
  import config from './Config'

  Vue.use(VueAxios, axios)

  export default {
    props: {
      carId: String
    },
    data() {
      return {
        editBrand: false,
        editModel: false,
        editYear: false,
        editPrice: false,
        editDescription: false,

        quillOptionsDescription: {placeholder: this.$t('message.form.placeholder.description')},

        car: {photos: []},
        index: null,
        imageBase: config.urls.image_url
      }
    },
    components: {Clearfix, 'gallery': VueGallery, Icon, quillEditor},
    methods: {
      preparePhotos(merge) {
        return _.map(this.car.photos, (photo) => {
          return merge ? this.$t(config.urls.image_url, {
            car_id: this.car.id,
            file_name: photo.fileName
          }) : photo.fileName
        })
      },

      startBrandEdit() {
        this.editBrand = this.$store.state.auth.dealer
      },
      updateBrand() {
        Vue.axios.put(this.$t(config.urls.car_update_brand, {car_id: this.car.id}), {data: this.car.brand})
          .then(() => {
            miniToastr.success(this.$t('message.notification.saved'))
            this.editBrand = false
          })
          .catch(() => {
            miniToastr.error(this.$t('message.error.saving_failed'))
          })
      },

      startModelEdit() {
        this.editModel = this.$store.state.auth.dealer
      },
      updateModel() {
        Vue.axios.put(this.$t(config.urls.car_update_model, {car_id: this.car.id}), {data: this.car.model})
          .then(() => {
            miniToastr.success(this.$t('message.notification.saved'))
            this.editModel = false
          })
          .catch(() => {
            miniToastr.error(this.$t('message.error.saving_failed'))
          })
      },

      startYearEdit() {
        this.editYear = this.$store.state.auth.dealer
      },
      updateYear() {
        Vue.axios.put(this.$t(config.urls.car_update_year, {car_id: this.car.id}), {data: this.car.year})
          .then(() => {
            miniToastr.success(this.$t('message.notification.saved'))
            this.editYear = false
          })
          .catch(() => {
            miniToastr.error(this.$t('message.error.saving_failed'))
          })
      },

      startPriceEdit() {
        this.editPrice = this.$store.state.auth.dealer
      },
      updatePrice() {
        Vue.axios.put(this.$t(config.urls.car_update_price, {car_id: this.car.id}), {data: this.car.price})
          .then(() => {
            miniToastr.success(this.$t('message.notification.saved'))
            this.editPrice = false
          })
          .catch(() => {
            miniToastr.error(this.$t('message.error.saving_failed'))
          })
      },

      startDescriptionEdit() {
        this.editDescription = this.$store.state.auth.dealer
      },
      updateDescription() {
        Vue.axios.put(this.$t(config.urls.car_update_description, {car_id: this.car.id}), {data: this.car.description})
          .then(() => {
            miniToastr.success(this.$t('message.notification.saved'))
            this.editDescription = false
          })
          .catch(() => {
            miniToastr.error(this.$t('message.error.saving_failed'))
          })
      },
      changeDescription({html}) {
        this.car.description = html
      }
    },
    created() {
      Vue.axios.get(config.urls.car + this.carId).then((response) => {
        this.car = response.data
      })
    },
    computed: {
      editableClasses() {
        return {
          'editable-field': this.$store.state.auth.dealer
        }
      }
    }
  }
</script>

<style>
  #page-car {
    background: url('../../assets/img/bg/bg_renault_engine.jpg') center fixed no-repeat #b1b1b1;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// CarDetail.vue?52f13c79